<template lang="pug">
.crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addRecord, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
  modal-import(model="quotations")
  modal-authorize-quotation(:form='form')
  Loader(v-if="loader")
  .container-fluid
    vm-row.heading(vm-w="12")
      vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
        div
          h2 {{ $t('strings.quotations') }}:
          span {{ $t('strings.description', {attribute: $t('strings.quotations')}) }}
        div(style="display:none;")
          vm-button(type="default" icon="list")
          vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
      vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
        div
          vm-button(icon="plus" @click="addQuotation") {{ $t('strings.add') }}
          vm-tooltip(:text="$t('strings.options')" delay=".5s")
            vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
              vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

              vm-dropdown-menu
                vm-dropdown-item.d-flex.justify-content-between(@click="exportRecords")
                  vm-icon(icon="download-outline")
                  slot &nbsp;{{ $t('strings.report') }}
                vm-dropdown-item.d-flex.justify-content-between(@click="deleteRecordsConfirm" :disabled="!enabledDelete")
                  vm-icon(icon="trash-2-outline")
                  slot &nbsp;{{ $t('strings.delete') }}
                //- More options
                    Agrega mas acciones para colecciones de datos
    vm-row(vm-w="12")
      vm-col.card(vm-sm=12)
        vm-table(multiple v-model="selected"  max-height="350px" :data="quotations" )
          template(slot="header")
            .d-flex.justify-content-between
              vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="300px")
              .d-flex.justify-content-between
                vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                  vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="default" icon="funnel-outline" size="small")

                    vm-dropdown-menu(class="filters")
                      .heading.d-flex.justify-content-between
                        h4 {{ $t('strings.filters') }}
                        vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                      vm-select.filter(:placeholder="$t('strings.customer')" autocomplete :label="$t('strings.customer')" v-model="filters.where.customer.id")
                        vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in customers")
                      vm-select.filter(:placeholder="$t('strings.requisitioner')" autocomplete :label="$t('strings.requisitioner')" v-model="filters.where.requisitioners.id")
                        vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in requisitioners")
                      vm-select.filter(:placeholder="$t('strings.status')" autocomplete :label="$t('strings.status')" v-model="filters.where.status")
                        vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in statusFilter")
                      vm-date-picker.filter(type="daterange" :label="$t('quotations.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                      //- Add filters
                          Agrega los filtros que prefieras por ejemplo:
                          vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                            vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")

                          NOTA: (agregar clase .filter)
                      .filter.d-flex
                        vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('strings.'+ item)")
                  vm-order-by-item(value='id,asc' text='id' direction='down')
                  vm-order-by-item(value='id,desc' text='id' direction='up')
                vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                  vm-button(type="default" size="small" icon="list" style="display: none;")
                vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                  vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('quotations.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                .details(@click="editQuotation(data[indextr])")
                  slot(v-if="column == 'quotation_total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                  slot(v-if="column == 'customer'")  {{data[indextr]['customer']['name']}}
                  slot(v-if="column == 'currency'")  {{data[indextr]['currency'] ? data[indextr]['currency']['code'] : null }}
                  slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                  slot(v-if="column == 'created_by'")  {{data[indextr]['user']['name']}}
                  vm-icon(v-if="column == 'attached_file' && data[indextr]['files'].length > 0"  icon="checkmark-square-outline" color="#D06325" class="icon_attached")
                  vm-icon(v-if="column == 'attached_file' && data[indextr]['files'].length == 0"  icon="close-square-outline" color="#afbbc6" class="icon_attached")
                  slot(v-if="column != 'quotation_total' && column != 'attached_file' && column != 'customer' && column != 'created_by' && column != 'currency' && column != 'status' && column != 'created_at' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
                  vm-status-indicator(v-if="column == 'status'" :color="colorStatus(data[indextr]['status_display'])") {{data[indextr]['status_display']}}
              vm-td
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="editQuotation(data[indextr])")
                    vm-icon(icon="edit-2-outline")
                    slot &nbsp;{{ $t('strings.edit') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="cloneReportQuotation(data[indextr].id)")
                    vm-icon(icon="copy-outline")
                    slot &nbsp;{{ $t('quotations.clone') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="printReportQuotation(data[indextr].id)")
                    vm-icon(icon="download-outline")
                    slot &nbsp;{{ $t('strings.download') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] != '2'" @click="showAuthorizeQuotationModal(data[indextr], 'authorize')")
                    vm-icon(icon="checkmark-circle-2-outline")
                    slot &nbsp;{{ $t('strings.authorized') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="deleteRecordConfirm(data[indextr])")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
                  //- More actions
        vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
        transition(name="enter")
          .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotations')
const ModalImport = () => import('@/components/modals/ModalImport.vue')
const Loader = () => import('@/components/aditionals/Loader.vue')

export default {
  name: 'Quotations',
  components: {
    ModalImport,
    Loader,
    ModalAuthorizeQuotation: () => import('@/components/modals/ModalAuthorizeQuotation')
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: ['folio', 'customer', 'currency', 'created_by', 'status', 'attached_file', 'created_at'],
    columnsOrderBy: ['customer', 'currency'],
    attributeModal: 'folio',
    status: [],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        customer: {
          name: ''
        },
        requisitioners: {
          requisitioner_id: ''
        },
        folio: '',
        status: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    },
    statusFilter: [
      {
        text: 'Pendiente',
        value: 1
      },
      {
        text: 'Autorizada',
        value: 2
      },
      {
        text: 'Cancelada',
        value: 3
      }
    ]
  }),
  computed: {
    ...mapGetters(['quotations', 'catalog', 'pagination', 'filterParams', 'customers', 'requisitioners', 'loader'])
  },
  async created () {
    await this.loadCustomerCatalog()
    await this.loadRequisitionersCatalog({ page: 1 })
  },
  methods: {
    ...mapActions([
      'updateRecord',
      'deleteRecord',
      'deleteRecords',
      'loadRecords',
      'loadCatalog',
      'actionRecord',
      'setModalVisible',
      'setModalImportVisible',
      'exportRecords',
      'applyFilter',
      'printReportQuotation',
      'clearFilter',
      'loadCustomerCatalog',
      'loadRequisitionersCatalog',
      'cloneReportQuotation',
      'setAuthorizeQuotationModalVisible'
    ]),
    addQuotation () {
      this.$router.push('create-quotation')
    },
    editQuotation (payload, row) {
      this.$router.push(`create-quotation/${payload.id}`)
    },
    showAuthorizeQuotationModal (record) {
      this.form = { ...record }
      this.setAuthorizeQuotationModalVisible(true)
    },
    setActionRecord (record, action) {
      record.id && this.actionRecord({ id: record.id, action })
    },
    colorStatus (code) {
      switch (code.trim()) {
        case 'Pendiente':
          return 'warning'
        case 'Autorizada':
          return 'success'
        case 'Cancelada':
          return 'danger'
        default:
          return 'warning'
      }
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
.icon_attached {
  display: flex;
  justify-content: center;
}
</style>
